import { ThemeProvider } from "@/providers/ThemeProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./styles/globals.css";
import { GuestRoute, RequireAuth } from "./router";
import SignInPage from "./routes/signin";
import CallbackPage from "./routes/callback";
import WrongAppPage from "./routes/wrong-app";
import Jobs from "@/components/jobs/Jobs";
import Upload from "@/components/upload/Upload";
import { initAnalytics } from "./hooks/miscellaneous/useAnalyticsManager";
import Insights from "./components/insights/Insights";
import Export from "./components/export/Export";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

initAnalytics();

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider
          attribute="class"
          defaultTheme="light"
          enableSystem
          disableTransitionOnChange
        >
          <Router>
            <Routes>
              <Route element={<RequireAuth />}>
                <Route path="/" element={<Jobs />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/export" element={<Export />} />
                <Route path="/upload" element={<Upload />} />
              </Route>
              <Route path="/auth" element={<GuestRoute />}>
                <Route path="signin" element={<SignInPage />} />
              </Route>
              <Route path="/auth/callback" element={<CallbackPage />} />
              <Route path="/auth/wrong-app" element={<WrongAppPage />} />
            </Routes>
          </Router>
        </ThemeProvider>
      </QueryClientProvider>
      <Toaster style={{ width: "596px" }} />
    </>
  );
}

export default App;
